// Register permission helper. Merchant/superadmin owners bypass ALL permission checks; employee
// logins are gated on their granted codes. Non-hook (usable in event handlers).
import { getAuthDetails } from "../../Common/cookiesHelper";
import { hasMenuPermission } from "../../helperFunctions/permissionHelper";

export function isRegisterOwner() {
  const lt = getAuthDetails()?.LoginGetDashBoardRecordJson?.login_type;
  return lt === "merchant" || lt === "superadmin";
}

export function canRegister(menuKey) {
  return isRegisterOwner() || hasMenuPermission(menuKey);
}
